import React from 'react';
import PropTypes from 'prop-types';
import styles from './home-section-message.module.css';
import { Spring } from 'react-spring';
import * as easings from 'd3-ease';

const SectionMessage = props => {
  const { sectionMessage, white, isInView } = props;
  const whiteColor = '#ffffff';
  const animationConfig = {
    delay: 400,
    duration: 800,
    easing: easings.easeLinear,
  };

  const renderMessage = () => {
    const animationConfig = {
      delay: 200,
      duration: 700,
      easing: easings.easeLinear,
    };
    return (
      <Spring
        from={{ opacity: '0' }}
        to={{
          opacity: isInView ? '1' : '0',
        }}
        config={animationConfig}
      >
        {animation => (
          <div
            className={
              white ? [styles.copy, styles.white].join(' ') : styles.copy
            }
            dangerouslySetInnerHTML={{ __html: sectionMessage }}
            style={animation}
          />
        )}
      </Spring>
    );
  };

  return <div className={styles.wrapper}>{renderMessage()}</div>;
};

SectionMessage.propTypes = {
  sectionMessage: PropTypes.string,
  white: PropTypes.bool,
};

export default SectionMessage;



// WEBPACK FOOTER //
// ./src/components/home/home-section-message/index.js